module.exports = __webpack_public_path__ + "static/charles_khazoom-67e02055f7cb130bc6a93bd5d76276aa.jpeg";